var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { snakeCase } from 'lodash';
import styled from 'styled-components';
import { Checkbox, ListItemText, TextField } from '@material-ui/core';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons';
const filterOptions = createFilterOptions();
const StyledListItemText = styled(ListItemText) `
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 8px;
`;
export const EntityColumnPicker = (_a) => {
    var { disableClearable, entity, disabled, error, helperText, filter = () => true, onAdd, onChange } = _a, props = __rest(_a, ["disableClearable", "entity", "disabled", "error", "helperText", "filter", "onAdd", "onChange"]);
    const [inputValue, setInputValue] = useState('');
    const getSelected = () => {
        const result = ((entity === null || entity === void 0 ? void 0 : entity.columns) || []).filter(column => {
            const name = column.columnName || snakeCase(column.displayName);
            const value = props.multiple
                ? props.value.map(v => snakeCase(v))
                : snakeCase(props.value);
            return props.multiple ? value.includes(name) : value === name;
        });
        return props.multiple ? result : result[0] || null;
    };
    const options = ((entity === null || entity === void 0 ? void 0 : entity.columns) || []).filter(filter);
    return (React.createElement(Autocomplete, { fullWidth: true, disableClearable: disableClearable, size: 'small', value: getSelected(), disabled: disabled, multiple: props.multiple, disableCloseOnSelect: props.multiple, options: options, getOptionLabel: option => option.displayName, onChange: (_, value) => {
            var _a;
            if ((_a = value) === null || _a === void 0 ? void 0 : _a.freesolo) {
                onAdd === null || onAdd === void 0 ? void 0 : onAdd(value.displayName);
            }
            else {
                onChange === null || onChange === void 0 ? void 0 : onChange(value);
            }
        }, onInputChange: (_, value) => setInputValue(value), filterOptions: (options, params) => {
            const filtered = filterOptions(options, params);
            if (onAdd && filtered.length === 0 && inputValue.length > 0) {
                filtered.push({ freesolo: true, displayName: inputValue });
            }
            return filtered;
        }, renderInput: params => (React.createElement(TextField, Object.assign({}, params, { error: error, helperText: helperText, variant: 'outlined', placeholder: `Select column${props.multiple ? 's' : ''}` }, props))), renderOption: (option, { selected }) => (React.createElement(React.Fragment, null,
            props.multiple && (React.createElement(Checkbox, { checked: selected, checkedIcon: React.createElement(CheckBox, { fontSize: 'small' }), icon: React.createElement(CheckBoxOutlineBlank, { fontSize: 'small' }) })),
            React.createElement(StyledListItemText, { primary: option.freesolo
                    ? `Add "${inputValue}" Column`
                    : option.displayName }))) }));
};
export default EntityColumnPicker;
//# sourceMappingURL=EntityColumnPicker.js.map